import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { ChecklistEndpointModel } from '../../shared/model/checklist-endpoint.model';
import { ChecklistEndpointService } from '../../shared/service/checklist-endpoint.service';
import { take } from 'rxjs/operators';

@Component({
	styleUrls: [],
	selector: 'app-endpoint-form',
	templateUrl: './endpoint-form.component.html',
})
export class ChecklistEndpointFormComponent implements OnInit {
	@Output() saveEndpoint = new EventEmitter<ChecklistEndpointModel | null>();

	@Input() endpoint: ChecklistEndpointModel;
	@Input() checklistId = null;

	constructor(private endpointService: ChecklistEndpointService) {}

	ngOnInit() {
		this.loadChecklistEndpoint();
	}

	loadChecklistEndpoint() {
		if (!this.endpoint) {
			this.endpoint = new ChecklistEndpointModel();
			this.endpoint.checklist_id = this.checklistId;
		};
	}

	validateEndpoint() {
		if (!this.endpoint.external_api || !this.endpoint.external_api.includes('http')) {
			return this.saveEndpoint.emit(null);
		}

		this.endpointService.getExternal(
			this.endpoint.external_api + '?' + this.endpoint.additional_params,
			this.endpoint.external_token
		).pipe(take(1)).subscribe(data => {
			this.saveEndpoint.emit(this.endpoint);
			console.info('Success', data);
		}, ({error}) => {
			this.saveEndpoint.emit(null);
			console.error(error);
		});
	}
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/checklist-form/endpoint-form/endpoint-form.component.ts